export default __webpack_public_path__ + "static/media/Illustration_3.e508b112.svg";